module.exports = __webpack_public_path__ + "static/media/pavol.d6343aa4.PNG";